export enum ContractStatus {
  IN_ANALYSIS = 'in_analysis',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export const convertContractStatus = (docStatus: ContractStatus): string => {
  let word: string;
  switch (docStatus) {
    case ContractStatus.IN_ANALYSIS:
      word = 'em análise';
      break;
    case ContractStatus.APPROVED:
      word = 'aprovado';
      break;
    case ContractStatus.REJECTED:
      word = 'rejeitado';
      break;
    default:
      word = '';
  }
  return word;
};

export enum NoticeCompanyType {
  SELECT = 0,
  INDIVIDUAL = 1,
  LIMITED_SOCIETY = 2,
  LIMITED_UNIPERSONAL_SOCIETY = 3,
  ANONYMOUS = 4,
  SIMPLE_SOCIETY = 5,
  COOPERATIVE = 6,
  EIRELI = 7,
}

export const convertNoticeCompanyType = (
  enumType: NoticeCompanyType
): string => {
  let word: string;
  switch (enumType) {
    case NoticeCompanyType.SELECT:
      word = 'selecione uma opção';
      break;
    case NoticeCompanyType.INDIVIDUAL:
      word = 'Empresário Individual (EI)';
      break;
    case NoticeCompanyType.LIMITED_SOCIETY:
      word = 'Sociedade limitada (LTDA)';
      break;
    case NoticeCompanyType.LIMITED_UNIPERSONAL_SOCIETY:
      word = 'Sociedade limitada unipessoal (SLU)';
      break;
    case NoticeCompanyType.ANONYMOUS:
      word = 'Sociedade anônima (S.A.)';
      break;
    case NoticeCompanyType.SIMPLE_SOCIETY:
      word = 'Sociedade simples';
      break;
    case NoticeCompanyType.COOPERATIVE:
      word = 'Cooperativa';
      break;
    case NoticeCompanyType.EIRELI:
      word = 'EIRELI (resquícios antigos)';
      break;
    default:
      word = '';
  }
  return word;
};
